import { LoadingState } from "types";

export interface InstructionsState {
  pushLoading: LoadingState;
  pushResult: string | null;
  pushErrorMessage?: string;
  downloadLoading: LoadingState;
  downloadResult: boolean | null;
  downloadErrorMessage?: string;
}

export const initialInstructionsState: InstructionsState = {
  pushResult: null,
  downloadLoading: LoadingState.idle,
  downloadResult: null,
  pushLoading: LoadingState.idle,
};
